/**
 * Format milliseconds into human-readable duration.
 *
 * Under 1s:  "0.12s"
 * Under 60s: "12.34s"
 * Over 60s:  "1:23.45"
 */
export function formatDuration(ms: number): string {
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(2)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds - minutes * 60;
  return `${minutes}:${remainder.toFixed(2).padStart(5, '0')}`;
}
